import { render, staticRenderFns } from "./AddPlatformTemplateComponent.vue?vue&type=template&id=995318ec&"
import script from "./AddPlatformTemplateComponent.vue?vue&type=script&lang=js&"
export * from "./AddPlatformTemplateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports